const getSideOptions = () => {
    return {
        type: 'GET_SIDE_OPTIONS',
        payload: ['left', 'both', 'right']
    };
};

const setCurrentSide = (side) => {
    return {
        type: 'SET_CURRENT_SIDE',
        payload: side
    };
};

const getCurrentSide = (side) => {
    return {
        type: 'GET_CURRENT_SIDE',
        payload: side
    };
};
//eslint-disable-next-line
export default {
    getSideOptions,
    setCurrentSide,
    getCurrentSide
};
